import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { loanSaleTradeInputs } from './constants'
import { type ILoanSaleTrade, emptyLoanSaleTrade } from './types'

export const EditLoanSaleTradeDialog = ({
  item,
  loanOptions,
  onClose,
  onSave,
}: {
  item: Partial<ILoanSaleTrade> | null
  loanOptions: Record<string, string>
  onClose: () => void
  onSave: (data: Partial<ILoanSaleTrade>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<ILoanSaleTrade>>(emptyLoanSaleTrade())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({ ...item })
  }, [item])

  const inputs = useMemo(() => loanSaleTradeInputs(form, loanOptions), [form, loanOptions])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    if (key === 'settled') {
      setForm((prev) => ({ ...prev, settled: value === 'true' || value === true }))
      return
    }
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        loanId: form.loanId,
        tradeType: form.tradeType,
        settled: Boolean(form.settled),
        srp: Number(form.srp || 0),
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit Loan Sale / Trade' : 'Add Loan Sale / Trade'}
      loading={saving}
      disabled={!form.loanId?.trim()}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
